import VideoColor from './VideoColour.svg';
import VideoDark from './VideoDark.svg';
import VideoLight from './VideoLight.svg';
export const video = { color: VideoColor, dark: VideoDark, light: VideoLight };
//# sourceMappingURL=index.js.map